export default {
	sectionTitle: {
		en: 'Contact us'
	},
	paragraphOne: {
		en: 'Your text goes here. Insert your content, thoughts, or information in this space.'
	},
	nameOne: {
		en: 'Jane Doe'
	},
	memberEmailOne: {
		en: 'company@email.com'
	},
	memberPhoneOne: {
		en: '+1 23 456 789'
	},
	memberDescOne: {	
		en: 'CEO at Company'
	},

  	paragraphTwo: {
		en: 'Your text goes here. Insert your content, thoughts, or information in this space.'
	},
	nameTwo: {
		en: 'Jane Doe'
	},
	memberEmailTwo: {
		en: 'company@email.com'
	},
	memberPhoneTwo: {
		en: '+1 23 456 789'
	},
	memberDescTwo: {	
		en: 'CEO at Company'
	},
};
